import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCircleXmark, faPlus, faCheck, faXmark, faSpinner, faInbox } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { InputText } from 'primereact/inputtext';
import './watchlistAddModal.scss';
import { Checkbox } from 'primereact/checkbox';
import { DashboardServiceApi } from '../../services/watchlist/api';
import { Configuration } from '../../services/watchlist/configuration';
import lodash from 'lodash';
import { Toast } from 'primereact/toast';
import { useDispatch, useSelector } from 'react-redux';
import { WatchListAllSymbolsServiceApi } from '../../services/actionHub/api';
import { Configuration as WatchListAllSymbolsServiceConfiguration } from '../../services/actionHub/configuration';
import { addItemToWatchlist, removeItemFromWatchlist, setWatchlist } from '../../stores/watchlist';
import { useToast } from '../../context/toast-context';
import { useTranslation } from 'react-i18next';
import Spinner from '../spinner';

const WatchlistAddModal = (props) => {
    const { t } = useTranslation();
    const watchlistApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }));
    const watchListAllSymbolsServiceApi = new WatchListAllSymbolsServiceApi(new WatchListAllSymbolsServiceConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }));
    const token = localStorage.getItem('token');
    // const toast = useRef(null);
    const toast = useToast();

    const [watchlistsData, setWatchlistsData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [newListNameValue, setNewListNameValue] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedEntityId, setSelectedEntityId] = useState("");
    const [visibleInput, setVisibleInput] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const dispatch = useDispatch();
    const watchlist = useSelector(state => state.watchlist.list);
    const [selectedItemCode, setSelectedItemCode] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Add loading state
    const [isListLoading, setIsListLoading] = useState(false);

    useEffect(() => {
        if (props.data) {
            const normalizedCode = props.data.code ?? props.data.Code;
            setSelectedItemCode(normalizedCode);
            setSelectedEntityId(props.data.entityId);
            updateSelectedItems(normalizedCode);
        }
    }, [props.data]);

    useEffect(() => {
        if (visible) {
            getWatchlist();
        }
    }, [visible]);

    useEffect(() => {
        if (selectedItemCode) {
            updateSelectedItems(selectedItemCode);
        }
    }, [watchlist]);

    const handleShow = (data) => {
        
        setVisible(true);
        updateSelectedItems(data.Code || data.code);
    };

    const handleClose = () => {
        setVisible(false);
        if (props.onUpdateData) {
            props.onUpdateData({ ...props.data, isFav: watchlist.some(it => it.code === selectedItemCode) });
        }
    };

    const updateSelectedItems = (code) => {
        const updatedWatchlistIds = watchlist
            .filter(it => it.code === code)
            .map(it => it.watchlistId);

        setSelectedItems(updatedWatchlistIds);
    };

    const handleCheckboxChange = (changedItem) => {
        setSelectedItems(prevSelectedItems => {
            if (prevSelectedItems.includes(changedItem.id)) {
                return prevSelectedItems.filter(id => id !== changedItem.id);
            } else {
                return [...prevSelectedItems, changedItem.id];
            }
        });
    };

    const handleSave = async () => {
        setIsLoading(true); // Set loading to true at the start

        const previousIds = new Set(
            watchlist.filter(it => it.code === selectedItemCode).map(it => it.watchlistId)
        );
        const newIds = new Set(selectedItems);
        const toRemove = [...previousIds].filter(id => !newIds.has(id));
        const toAdd = [...newIds].filter(id => !previousIds.has(id));

        try {
            for (const id of toRemove) {
                await removeItem(id);
                dispatch(removeItemFromWatchlist({ code: selectedItemCode, watchlistId: id }));
            }

            for (const id of toAdd) {
                
                await addItem(id);
                dispatch(addItemToWatchlist({ code: selectedItemCode, watchlistId: id }));
            }

            await getUserWatchlistData(token);

            handleClose();

        } catch (error) {
            console.log("handleSave: ", error);
            toast.current.show({
                severity: 'error',
                summary: t('watchList.error.handleSave'),
                detail: t('watchList.error.operationFailed'),
                life: 3000,
            });
        } finally {
            setIsLoading(false); // Set loading to false when done, whether success or failure
        }
    };



    const getWatchlist = () => {
        setIsListLoading(true);
        const culture = "tr-TR";

        watchlistApi.watchlistListGet(token, culture).then((res) => {
            

            let data = res.data.items;
            data = data.filter(element => !element.id.includes('xu030') && !element.id.includes('xu100'));

            const mappedWatchlistData = lodash.map(data, (res) => ({
                name: res.name,
                id: res.id,
                count: res.securityCount,
            }));
            lodash.remove(mappedWatchlistData, { id: "predefinedxu030.SNE7uSuy" });
            setWatchlistsData(mappedWatchlistData);
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setIsListLoading(false);
        });
    };

    const addItem = async (id) => {
        await watchlistApi.watchlistAddSymbolGet(token, id, selectedEntityId).then((res) => {
            if (!res.data.error) {
                
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t('watchList.symbolAdded', { code: selectedItemCode }),
                    life: 3000,
                });
            } else {
                if (res.data.error.includes("already exists")) {
                    toast.current.show({
                        severity: 'error',
                        summary: t('error'),
                        detail: t('watchList.symbolAlreadyExists', { code: selectedItemCode }),
                        life: 3000,
                    });
                }
                else {
                    toast.current.show({
                        severity: 'error',
                        summary: t('errorOccurred'),
                        detail: res.data.error ? `${t('componentErrors.serviceErrorCode')}${res.data.error}` : t('watchList.error.operationFailed'),
                        life: 3000,
                    });
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const removeItem = async (removedListId) => {
        await watchlistApi.watchlistRemoveSymbolGet(token, removedListId, selectedEntityId).then((res) => {
            if (!res.data.error) {
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t('watchList.symbolRemoved', { code: selectedItemCode }),
                    life: 3000,
                });
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: t('errorOccurred'),
                    detail: res.data.error ? `${t('componentErrors.serviceErrorCode')}${res.data.error}` : t('watchList.error.operationFailed'),
                    life: 3000,
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const createWatchlist = () => {
        const culture = "tr-TR";
        const name = inputValue;

        if (inputValue === "") {
            toast.current.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('watchList.emptyListName'),
                life: 3000,
            });
            return;
        }

        watchlistApi.watchlistNewGet(token, name).then((res) => {
            
            if (!res.data.error) {
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t('watchList.successCreateList', { listName: name }),
                    life: 3000,
                });
                getWatchlist();
                setInputValue('');
                setVisibleInput(false);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: t('unsuccessful'),
                    detail: t('watchList.error.createList', { error: res.data.error }),
                    life: 3000,
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const getUserWatchlistData = (token) => {
        const culture = "tr-TR";
        watchListAllSymbolsServiceApi.actionhubWatchlistallsymbolsGet(token, culture).then((response) => {
            if (!response.data.error) {
                console.log("getUserWatchlistData Updated List : ", response.data.watchlist);
                let data = response.data.watchlist;
                data = data.filter(element => !element.id.includes('xu030') && !element.id.includes('xu100'));

                const favoritesSecuritiesData = data.flatMap(element =>
                    element.securitiesEntityIds.map(security => ({
                        ...security,
                        watchlistId: element.id,
                        watchlistName: element.name,
                    }))
                );
                dispatch(setWatchlist(favoritesSecuritiesData));
            } else {
                console.error("getUserWatchlistData:", response.data.error);
            }
        }).catch((err) => {
            console.error("getUserWatchlistData error:", err);
        });
    };

    return (
        <div className='watchlist-add-modal-component'>
            {/* <Toast ref={toast} position="bottom-right" className='watchlist-toast' style={{ zIndex: 9999 }} /> */}

            {props.data && props.from && props.from === 'stockAnalysis' &&
                <div className='stock-analysis-watchlist-button' onClick={(event) => handleShow(props.data, event)}>
                    {watchlist.some(it => it.code === (props.data.Code || props.data.code)) && <FontAwesomeIcon className='icon' icon={faStar} style={{ color: '#EDB618' }} />}
                    {!watchlist.some(it => it.code === (props.data.Code || props.data.code)) && <FontAwesomeIcon className='regularStar icon' icon={faStarRegular} />}
                    <label className='m-auto '>
                        İZLEME LİSTESİ
                    </label>
                </div>
            }

            {props.data && props.from !== 'stockAnalysis' && !watchlist.some(it => it.code === (props.data.Code || props.data.code)) &&
                <FontAwesomeIcon className='regularStar' icon={faStarRegular} onClick={() => handleShow(props.data)} />
            }

            {props.data && props.from !== 'stockAnalysis' && watchlist.some(it => it.code === (props.data.Code || props.data.code)) &&
                <FontAwesomeIcon icon={faStar} style={{ color: '#EDB618' }} onClick={(event) => handleShow(props.data)} />
            }

            <Modal show={visible} onHide={handleClose}
                className='watchlistAddModal'
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header className='watchlistAddModalHeader'>
                    <Container className='container'>
                        <Row className='columnsSelectHeaderRow cursor-pointer'>
                            <Col md="11" className='color-text roboto-bold-18 '>{t('watchList.modalTitle')} - {selectedItemCode} </Col>
                            <Col md="1"><FontAwesomeIcon className='modalCloseIcon text-align-right float-right cursor-pointer' icon={faCircleXmark} onClick={handleClose} style={{ border: 'none' }} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='watchlistAddModalBody'>
                    <Container className='modalBodyContainer'>
                        {isListLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                                <Spinner />
                            </div>
                        ) : watchlistsData.length > 0 ? (
                            <div className='list-row'>
                                <Row >
                                    {watchlistsData.map((item) => (
                                        <Col key={item.id} md="6" className='listItemCol'>
                                            <Row >
                                                <Col md='4'>
                                                    <div className='checkListCol'>
                                                        <Checkbox
                                                            className='checkbox'
                                                            onChange={() => handleCheckboxChange(item)}
                                                            checked={selectedItems.includes(item.id)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md='8' className='m-auto'>
                                                    <Row>
                                                        <div className='roboto-medium-14'>{item.name}</div>
                                                    </Row>
                                                    <Row>
                                                        <div className='roboto-regular-12'>  {item.count} Hisse Senedi</div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <FontAwesomeIcon icon={faInbox} size="3x" className="text-muted mb-3" />
                                <h4>{t('watchList.noWatchlists')}</h4>
                                <p className="text-muted">{t('watchList.noWatchlistsDescription')}</p>
                            </div>
                        )}


                        {!visibleInput &&
                            <Row className='m-t-20' onClick={() => setVisibleInput(true)} >
                                <Col md='2'>
                                    <div className='newListCreate cursor-pointer'>
                                        <FontAwesomeIcon className='newListCreateIcon ' icon={faPlus} onClick={() => setVisibleInput(true)} />
                                    </div>
                                </Col>
                                <Col md='10' className='newListCreateTitle roboto-medium-16 cursor-pointer'>
                                    {t('watchList.creatNewWatchList')}
                                </Col>
                            </Row>
                        }
                        {visibleInput &&
                            <Row className='m-t-20'>
                                <Col md='8' className='roboto-medium-16 m-auto p-0'>
                                    <InputText className='newListCreateInput' placeholder={t('listName')} value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                                </Col>
                                <Col md='4' className='action-buttons'>
                                    <div className='newListCreateOkeyButton  cursor-pointer' onClick={() => createWatchlist()} >
                                        <FontAwesomeIcon className='newListCreateIcon' icon={faCheck} />
                                    </div>
                                    <div className='newListCreateDismissButton cursor-pointer' onClick={() => setVisibleInput(false)} >
                                        <FontAwesomeIcon className='newListCreateIcon' icon={faXmark} />
                                    </div>
                                </Col>
                            </Row>
                        }
                    </Container>
                </Modal.Body>
                <Modal.Footer className='watchlistAddModalFooter'>
                    <Container>
                        <Row>
                            <Col md='12'>
                                <Button
                                    className='watchlistAddModalSaveButton roboto-bold-17'
                                    variant="primary"
                                    onClick={handleSave}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <span className="button-spinner-container">
                                            <FontAwesomeIcon icon={faSpinner} spin size="lg" style={{ marginRight: '8px' }} />
                                            {t('save')}
                                        </span>
                                    ) : (
                                        t('save')
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default WatchlistAddModal;
